
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import ModuleLayout from '../../layouts/ModuleLayout';
import TabContainer from '../../components/navigation/TabContainer';
import Drawer from '../../components/common/Drawer';

// Import Tab Components
import JobPosts from './recruitment/JobPosts';
import {
    CandidatePipeline,
    InterviewScheduling,
    CandidateDocumentation,
    OfferManagement,
    RecruitmentAnalytics,
    CandidateProfileManagement,
    OfferCommunicationLogs
} from './recruitment/index';

// Drawer components for other actions can be imported here
// For now, we focus on the requested Job actions

const RecruitmentModule = ({ initialTab }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    // Determine active tab from URL or props
    const activeTab = searchParams.get('tab') || initialTab || 'jobs';

    // Drawer state from URL
    const action = searchParams.get('action');
    const actionId = searchParams.get('id');

    // Tab Registry
    const tabRegistry = {
        jobs: JobPosts,
        pipeline: CandidatePipeline,
        interviews: InterviewScheduling,
        documentation: CandidateDocumentation,
        documentations: CandidateDocumentation,
        offers: OfferManagement,
        analytics: RecruitmentAnalytics,
        candidates: CandidateProfileManagement,
        logs: OfferCommunicationLogs
    };

    // Tab Configuration for Layout
    const tabs = [
        { id: 'jobs', label: 'Jobs' },
        { id: 'candidates', label: 'Candidates' },
        { id: 'pipeline', label: 'Hiring Pipeline' },
        { id: 'interviews', label: 'Interviews' },
        { id: 'documentation', label: 'Documentation' },
        { id: 'offers', label: 'Offers' },
        { id: 'analytics', label: 'Recruitment Analytics' },
        { id: 'logs', label: 'Activity Logs' },
    ];

    // Handlers
    const handleTabChange = (tabId) => {
        setSearchParams({ tab: tabId });
    };

    const handleCloseDrawer = () => {
        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.delete('action');
            newParams.delete('id');
            return newParams;
        });
    };

    // Primary Action Logic (Header Button)
    const getPrimaryAction = () => {
        // Redundant "Create Job" button removed as JobPosts already has a "Create Job Posting" button
        return null;
    };

    // Drawer Content Logic
    const renderDrawerContent = () => {
        if (!action) return null;

        switch (action) {
            // Add other cases here for candidateProfile etc.

            default:
                return (
                    <div className="p-4 text-red-500">
                        Unknown action: {action}
                    </div>
                );
        }
    };

    const getDrawerTitle = () => {
        switch (action) {
            default: return '';
        }
    };

    return (
        <ModuleLayout
            title="Recruitment"
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
            action={getPrimaryAction()}
        >
            <TabContainer
                activeTab={activeTab}
                tabRegistry={tabRegistry}
            />

            {/* Action Drawer */}
            <Drawer
                isOpen={!!action}
                onClose={handleCloseDrawer}
                title={getDrawerTitle()}
                size="full" // Full screen for complex forms like Create/Edit Job
                hideCloseButton={false}
            >
                {renderDrawerContent()}
            </Drawer>
        </ModuleLayout>
    );
};

export default RecruitmentModule;
